import store from '@/helpers/store'

export default (to, from, next) => {
  console.log('to', to);
  if (store.getters['auth/user'].role && store.getters['auth/user'].role === 'Admin') {
    next()
  } else {
    next({ name: 'ProblemaAplicatie' })
  }
}
